import React, { useCallback, useState } from 'react';
import styles from './hsaChangePassword.module.scss';
import ParentAuthPageLayout from '../../../components/auth-page-layout/HsaAuthPageLayout';
import { TextInput, TextInputValue } from '../../../components/text-input/TextInput';
import { gql, useMutation } from '@apollo/client';
import { validatePassword } from '../../../utils/validation';
import Button from 'src/components/button/Button';

type Props = {};

const ResetEmailMutation = gql`
    mutation hsaChangePassword($email: String!, $oldPassword: String!, $newPassword: String!) {
      hsaChangePassword(input: { email: $email, oldPassword: $oldPassword, newPassword: $newPassword })
    }
`

type ResetEmailResponse = {
  hsaChangePassword: boolean;
}

function HSAChangePassword(props: Props) {

  return (
    <ParentAuthPageLayout backToLogin={true} title={'Reset your password'}>
      <ResetFormContent />
    </ParentAuthPageLayout>
  );
}
const ResetFormContent = () => {

  const [reset, { loading, error }] = useMutation<ResetEmailResponse>(ResetEmailMutation, {
    onCompleted: () => {
      setCompleted(true);
    },
    onError: () => {
      setCompleted(true);
    }
  });

  const [clientError, setClientError] = useState<undefined | string>();
  const [completed, setCompleted] = useState(false);

  const [email, setEmail] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');

  const handleChange = useCallback((setter) => (value: TextInputValue) => {
    setClientError(undefined);
    setter(value);
  }, []);

  const handleSubmit = useCallback(() => {

    const oldP = validatePassword(oldPassword);
    if (oldP) {
      return setClientError(oldP);
    }

    const newP = validatePassword(newPassword);
    if (newP) {
      return setClientError(newP);
    }

    // if (password !== confirmPassword) {
    //   return setClientError('The password and the confirm password should match.')
    // }

    reset({ variables: { email, oldPassword, newPassword } });
  }, [oldPassword, newPassword, reset, email]);

  return (
    <>
    {completed ? (
      <>
      {error ?(
        <div className={styles.confirm}>
          <div className={styles.confirmErrorTitle}>Error!</div>
          <div className={styles.confirmSubtitle}>{error.message}</div>
        </div>
        ) : (
        <div className={styles.confirm}>
          <div className={styles.confirmTitle}>Your password has been set successfully!</div>
          <div/>
        </div>
        )}
      </>
    ) : <>
        <div className={styles.formWrapper}>
          <TextInput allowSpecialCharacters type={'text'} className={styles.input} value={email} 
                     onChange={handleChange(setEmail)} label={'Email:'} id={'email'}
                     placeholder={'Email'}/>
          <TextInput allowSpecialCharacters type={'password'} className={styles.input} placeholder={'Old password'} label={'Old password*'}
                    id={'password'}
                    value={oldPassword} onChange={handleChange(setOldPassword)}/>
          <TextInput allowSpecialCharacters type={'password'} className={styles.input} placeholder={'New password'}
                    label={'New password*'}
                    id={'confirmPassword'} value={newPassword} onChange={handleChange(setNewPassword)}/>
          {!!clientError && <div className={styles.error}>{clientError}</div>}
          <Button disabled={loading} className={styles.submit} onClick={handleSubmit} label={'Reset password'} />
        </div>
      </>
    }
    </>
  )
};
export default HSAChangePassword;
